module.exports = __webpack_public_path__ + "img/20190705162138960.5d8127cb.png";